module.exports = __webpack_public_path__ + "img/videoImg.71510905.jpg";